import { render, staticRenderFns } from "./DeviceTypeI18n.vue?vue&type=template&id=16d75e38&scoped=true"
import script from "./DeviceTypeI18n.vue?vue&type=script&lang=js"
export * from "./DeviceTypeI18n.vue?vue&type=script&lang=js"
import style0 from "./DeviceTypeI18n.vue?vue&type=style&index=0&id=16d75e38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d75e38",
  null
  
)

export default component.exports